import { computedAsync, type AsyncComputedOptions } from '@vueuse/core'
import type { EventPlatform } from '@/types'
import { getEventPlatforms } from '@/api'

export const useEventPlatformsAsync = (options?: AsyncComputedOptions) => {
    return computedAsync<EventPlatform[]>(
        (onCancel) => {
            const abortController = new AbortController()

            onCancel(() => abortController.abort())

            return getEventPlatforms(abortController.signal)
        },
        [],
        options,
    )
}
